module.exports = __webpack_public_path__ + "img/device_1012_2.2454ec1b.svg";